module.exports = __webpack_public_path__ + "static/media/C028.e120b0fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C028.jpg
// module id = 311
// module chunks = 0